import { render, staticRenderFns } from "./AvatarOrIcon.vue?vue&type=template&id=0c7db73b&scoped=true"
import script from "./AvatarOrIcon.vue?vue&type=script&lang=js"
export * from "./AvatarOrIcon.vue?vue&type=script&lang=js"
import style0 from "./AvatarOrIcon.vue?vue&type=style&index=0&id=0c7db73b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c7db73b",
  null
  
)

export default component.exports